import React, { useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, Navigate } from "react-router-dom";
import AppMobilePage from "../appMobile";
import ClassificatorPage from "../classificator/index";
import DashboardView from "../dashboard";
import DocumentDetail from "../documentDetail/index";
import DocumentsWithSearch from "../documentsWithSearch/index";
import {DocumentsVersionChooser} from "../documentsWithSearch/DocumentsVersionChooser";
import ProfilePage from "../profile";
import DeadlinesView from "../deadlines/index";
import DeadlinesCreateView from "../deadlines/create";
import SettingsPage from "../settings";
import CustomerFormView from "../customerForm";
import StatisticsView from "../customerForm/statistics/index";
import SignaturePage from "../signature";
import SignatureStudio from "../signature/studio";
import SSOView from "../sso";
import UploadPage from "../upload";
import DetailDeadlinesView from "../deadlines/detail";
import FoldersView from "../folders";
import FoldersEditView from "../folders/edit";
import AskEditView from "../ask/edit";
import AskListView from "../ask/list";
import AskAnswerView from "../ask/answer";
import CustomersListView from "../customers/index";
import LandingNoDataView from "../customerForm/landingNoDataView";
import LandingNoTSPay from "../customerForm/landingNoTSPay";
import DetailTemplateView from "../ask/dots/detailTemplateView";
import { usePermissions } from "../../customHooks";
import Spinner from "../../components/general/spinner/index";
import FulfilmentView from "../fulfilment/index";
import FulfilmentActivitiesView from "../fulfilment/activities";
import TSPayPaymentView from "../tspay/payment";
import TsPayOnboardingLandingView from "../tspay/onboarding";
import TSPayCompletedPayment from "../../components/general/tspay/registerDialog/completedPayment";
import TSPayCompletedConsents from "../../components/general/tspay/consentsDialog/completedConsents";
import CompaniesRatingView from "../rating/index";
import CheckupView from "../checkup/index";
import ReportsView from "../report";
import TaxCreditView from "../taxCredit";
import TaxCreditDetailView from "../taxCredit/detail";
import CreateNewContactView from "../parties/createNewContactView";
import NewAccountingYearView from "../accountingYears/createNew";
import AccountingYearsListView from "../accountingYears/list";

import {
  FEATURE_TOGGLE_DATI_SCHEDA_CLIENTE,
  FEATURE_TOGGLE_ASK,
  FEATURE_TOGGLE_FULFILMENTS,
  FEATURE_TOGGLE_TSPAY,
  FEATURE_TOGGLE_RECONCILIATION,
  FEATURE_TOGGLE_PARTIES,
  FEATURE_TOGGLE_PRE_COG,
  FEATURE_TOGGLE_REPORTS,
  FEATURE_TOGGLE_TAX_CREDIT,
  FEATURE_TOGGLE_CHART_ACCOUNTS,
  FEATURE_TOGGLE_F24,
  CUSTOMER_MANAGEMENT_URL,
  BRANCH_NAME
} from "../../config";
import ReconciliationView from "../reconciliation";
import PartiesView from "../parties";
import PreCogView from "../preCog";
import PreCogDetail from "../preCog/detail";
import ChartAccountsView from "../chartAccounts";
import ReportsHomeView from "../report/home";
import VatReportView from "../report/vat";
import VatDetailReportView from "../report/vat/detail";
import AliquoteDetailView from "../report/vat/aliquoteDetail";
import F24View from "../f24";
import FixedUsedGoods from "../../components/preCog/detail/fixedUsedGoods";
import DbxChildAppView from "../childApp";
import { getPrecogConfig } from "../../store/actions/precog/config";
import VatEntriesView from "../report/vatEntries";
import ReportOnefront from "../reportOnefront";
import ChooserStudio from "./chooserStudio";

const RoutesView = (props) => {
  const dispatch = useDispatch();
  const pageRef = useRef();
  const currentPermissions = useSelector(state => state.currentPermissions);
  const main = useSelector(state => state.main);
  const user = useSelector(state => state.user);
  const isActiveStatus = useSelector(state => state?.precog?.precogConfig?.data?.active);

  const accountantSelected=main.accountantSelected;
  const companySelected=main.companySelected;
  const myType=main.myType;

  useEffect(() => {
    if (accountantSelected && companySelected) dispatch(getPrecogConfig());
  }, [accountantSelected, companySelected]);

  const {
    isPermissionDeadlines,
    isPermissionClientCard,
    isPermissionAsk,
    isPermissionFolderStudio,
    isPermissionFolderItem,
    isPermissionSignStudio,
    isPermissionSignItem
    
  } = usePermissions(currentPermissions, true);
  const isPermissionsEnded = currentPermissions?.permissionUser?.status?.ended;  
  return (
    <>
      {isPermissionsEnded || window.location.href.indexOf("/password-dimenticata") > 0 || window.location.href.indexOf("/iframe") > 0  ? (
        <Routes>

          <Route            
            path="/"    
            element={ <DashboardView
              pageRef={pageRef}              
            />}        
          />           

          <Route
            path="/sso"
            name="sso"  
            element={<SSOView />}       
          />
          
          {FEATURE_TOGGLE_DATI_SCHEDA_CLIENTE === "true" && (
            <Route              
              name="scheda"
              path="/scheda-cliente"
              element={
                (myType === "STUDIO" && isPermissionClientCard) ||
                myType !== "STUDIO" ? (
                    <CustomerFormView
                      pageRef={pageRef}                
                    />
                  ) : (
                    <Navigate to="/" />
                  )
              }      
            />
          )}

          <Route
            exact
            path="/tspaycompleted"     
            element={<TSPayCompletedPayment  />}              
          />

          <Route
            exact
            path = {"/tspayConsentsAccountsListCompleted"}            
            element={ <TSPayCompletedConsents />}       
          />

          <Route
            exact
            path = {"/tspayConsentsRecurringCompleted"}            
            element={ <TSPayCompletedConsents />}       
          />

          {FEATURE_TOGGLE_DATI_SCHEDA_CLIENTE === "true" && (
            <Route             
              name="statistiche"
              path="/statistiche"
              element={<StatisticsView
                pageRef={pageRef}                
              />}       
            />
          )}

          {FEATURE_TOGGLE_DATI_SCHEDA_CLIENTE === "true" && (
            <Route             
              name="landing-no-data"
              path="/landing-no-data"
              element={<LandingNoDataView
                pageRef={pageRef}               
              />}       
            />
          )}

          {FEATURE_TOGGLE_DATI_SCHEDA_CLIENTE === "true" && (
            <Route              
              name="landing-no-tspay"
              path="/landing-no-tspay"
              element={<LandingNoTSPay
                pageRef={pageRef}                  
              />}       
            />
          )}

          <Route          
            name="documenti"
            path="/documenti"
            element={ <DocumentsVersionChooser pageRef={pageRef} >
              <DocumentsWithSearch
                pageRef={pageRef}
              />
            </DocumentsVersionChooser>}
          />
          <Route            
            name="dettagliodocumento"
            path="/dettaglio-documento/:id"
            element=
              {
                accountantSelected &&
              companySelected &&              
              myType ? (
                    <DocumentDetail
                      pageRef={pageRef}
                    
                    />
                  ) : (
                    <Navigate to="/" />
                  )
              }    
          />
          
          <Route            
            name="upload"
            path="/carica-documenti"
            element={ <UploadPage
              pageRef={pageRef}
                
            />}       
          />
           
          <Route            
            name="signature"
            path="/da-firmare"
            element={
              isPermissionSignItem ? (
                <SignaturePage
                  pageRef={pageRef}                
                  iframe={false}
                />
              ) : (
                <Navigate to="/" />
              )
            }       
          />

          <Route            
            name="signDoc"
            path="/firma-documento"
            element={
              isPermissionSignItem ? (
                <SignaturePage
                  pageRef={pageRef}
                  
                  iframe={true}
                />
              ) : (
                <Navigate to="/" />
              )
            }    
          />
          <Route            
            name="digitalsign"
            path="/digital-sign"
            element={
              isPermissionSignStudio ? (
                <SignatureStudio
                  pageRef={pageRef}
                  
                />
              ) : (
                <Navigate to="/" />
              )
            }    
          />            
          <Route           
            name="downloadApp"
            path="/app-mobile"
            element={<AppMobilePage />}       
          />
          <Route           
            name="classificatorNew"
            path="/cambio-classificazione/:id"
            element={<ClassificatorPage
              pageRef={pageRef}
                
            />}       
          />
          
          <Route            
            name="settings"
            path="/impostazioni"
            element={
              currentPermissions.permissionClient.permissions !== null &&
              myType === "STUDIO" ? (
                  <SettingsPage
                    pageRef={pageRef}
                    
                  />
                ) : (
                  <Navigate to="/" />
                )
            }      
          />                    
          <Route           
            name="profile"
            path="/profilo"
            element={<ProfilePage pageRef={pageRef}/>}       
          />
          {main?.myType === "STUDIO" && <Route           
            name="studio"
            path="/choose-studio"
            element={<ChooserStudio visibleStudioModal={false} setVisibleStudioModal={() => {}} />}       
          />}
          <Route           
            name="deadlines"
            path={"/scadenzecliente"}
            element={
              isPermissionDeadlines ? (
                <DeadlinesView
                  pageRef={pageRef}
                  
                  isAll={false}
                />
              ) : (
                <Navigate to="/" />
              )
            }     
          />

          <Route           
            name="deadlines"
            path={"/scadenze" }
            element={
              isPermissionDeadlines ? (
                <DeadlinesView
                  pageRef={pageRef}                  
                  isAll={false}
                />
              ) : (
                <Navigate to="/" />
              )
            }     
          />
          <Route           
            name="deadlinesDetail"
            path="/scadenza/:id"
            element= {
              isPermissionDeadlines ? (
                <DetailDeadlinesView
                  pageRef={pageRef}
                  
                />
              ) : (
                <Navigate to="/" />
              )
            }      
          />           
          <Route           
            name="createDeadline"
            path="/creascadenza"
            element= {
              isPermissionDeadlines ? (
                <DeadlinesCreateView
                  pageRef={pageRef}

                />
              ) : (
                <Navigate to="/" />
              )
            }     
          />
           
          {
            <Route             
              name="folders"
              path="/folders"
              element={
                (myType === "STUDIO" && isPermissionFolderStudio) ||
                (myType !== "STUDIO" && isPermissionFolderItem) ? (
                    <FoldersView
                      pageRef={pageRef}
                      
                    />
                  ) : (
                    <Navigate to="/" />
                  )
              }     
            />
          }
          {
            <Route             
              name="folders-create"
              path="/folders-edit"
              element= {
                (myType === "STUDIO" && isPermissionFolderStudio) ||
                (myType !== "STUDIO" && isPermissionFolderItem) ? (
                    <FoldersEditView
                      pageRef={pageRef}
                      
                    />
                  ) : (
                    <Navigate to="/" />
                  )
              }       
            />
          }
          <Route
            name="folders-edit"
            path="/folders-edit/:id"
            element={
              (myType === "STUDIO" && isPermissionFolderStudio) ||
              (myType !== "STUDIO" && isPermissionFolderItem) ? (
                  <FoldersEditView
                    pageRef={pageRef}
                    
                  />
                ) : (
                  <Navigate to="/" />
                )
            }     
          />

          {FEATURE_TOGGLE_ASK === "true" && (
            <Route                           
              name="ask-edit"
              path="/ask-edit"
              element={
                isPermissionAsk ? (
                  <AskEditView
                    pageRef={pageRef}
                    
                  />
                ) : (
                  <Navigate to="/" />
                )
              }   
            />
          )}

          <Route            
            name="customers-list"
            path="/customers-list"
            element={<CustomersListView pageRef={pageRef} />}       
          />

          {(FEATURE_TOGGLE_ASK === "true" && (
            <Route             
              name="ask-list"
              path="/ask-list"
              element={ isPermissionAsk ? (
                <AskListView
                  pageRef={pageRef}
                      
                />
              ) : (
                <Navigate to="/" />
              )}       
            />
          )) ||
            null}

          {(FEATURE_TOGGLE_ASK === "true" && (
            <Route
              name="ask-answer"
              path="/ask-answer"
              element={
                isPermissionAsk ? (
                  <AskAnswerView
                    pageRef={pageRef}
                    
                  />
                ) : (
                  <Navigate to="/" />
                )
              }     
            />                          
          )) ||
            null}

          {(FEATURE_TOGGLE_ASK === "true" && (
            <Route
              name="ask-answer"
              path="/ask-answer/:id"
              element={
                isPermissionAsk ? (
                  <AskAnswerView
                    pageRef={pageRef}
                    
                  />
                ) : (
                  <Navigate to="/" />
                )
              }     
            />                          
          )) ||
            null}

          {(FEATURE_TOGGLE_ASK === "true" && (
            <Route              
              name="communitytemplate"
              path="/community-template/:id"
              element={ 
                myType === "STUDIO" && isPermissionAsk ? (
                  <DetailTemplateView
                    
                  />
                ) : (
                  <Navigate to="/" />
                )
              }     
            />
              
          )) ||
            null}
          <Route
            name="companies-rating"
            path="/companies-rating"
            element={ <CompaniesRatingView
              pageRef={pageRef}
                
            />}       
          />
          <Route            
            name="checkup"
            path="/checkup"
            element={<CheckupView
              pageRef={pageRef}
                
            />}       
          />
          {FEATURE_TOGGLE_FULFILMENTS === "true" && (
            <Route
              exact
              name="fulfilments"
              path="/fulfilments"
              element={<FulfilmentView
                pageRef={pageRef}

              />}
            />
          )}

          {FEATURE_TOGGLE_F24 === "true" && (
            <Route
              exact
              name="f24"
              path="/f24"
              element={<F24View
                pageRef={pageRef}

              />}
            />
          )}

          <Route            
            exact
            name="newAccountingYear"
            path="/new-accounting-year"
            element={<NewAccountingYearView
              pageRef={pageRef}
                  
            />}       
          />

          {FEATURE_TOGGLE_PRE_COG === "true" && isActiveStatus && (
            <Route            
              exact
              name="accountingYearsList"
              path="/accounting-years-list"
              element={<AccountingYearsListView
                pageRef={pageRef}
                  
              />}       
            />
          )}

          {FEATURE_TOGGLE_PRE_COG === "true" && isActiveStatus && (
            <Route            
              exact
              name="usedGoods"
              path="/used-goods"
              element={<FixedUsedGoods
                pageRef={pageRef}                  
              />}       
            />
          )}
          
          {FEATURE_TOGGLE_FULFILMENTS === "true" && (
            <Route              
              name="fulfilments-detail-activities"
              path="/fulfilments/activities/:id"
              element={<FulfilmentActivitiesView pageRef={pageRef}  />}       
            />
          )}

          {FEATURE_TOGGLE_RECONCILIATION === "true" && (
            <Route            
              name="bank_payments"
              path="/bank-payments"
              element={ <ReconciliationView
                pageRef={pageRef} myType={myType}
              />}       
            />
          )}
                    
          {FEATURE_TOGGLE_TSPAY === "true" && (
            <Route              
              name="tspaypayment"
              path="/tspay-payment"
              element={<TSPayPaymentView pageRef={pageRef}  />}       
            />
          )}

          {FEATURE_TOGGLE_PARTIES === "true" && (
            <Route              
              name="parties"
              path="/parties"
              element={<PartiesView pageRef={pageRef}  />}       
            />              
          )}

          {FEATURE_TOGGLE_PRE_COG === "true" && isActiveStatus && (
            <Route            
              name="precog"
              path="/precog"
              element={<PreCogView pageRef={pageRef}  />}       
            />
          )}

          {FEATURE_TOGGLE_PRE_COG === "true" && isActiveStatus  && (
            <Route          
              exact    
              name="precog-detail"
              path="/precog-detail/:id"
              element={<PreCogDetail pageRef={pageRef}  />}       
            />
          )}

          {FEATURE_TOGGLE_PRE_COG === "true" && isActiveStatus && (
            <Route
              name="precog-create"
              path="/precog-create"
              element={<PreCogDetail pageRef={pageRef}  isCreate={true} />}       
            />
          )}

          {FEATURE_TOGGLE_CHART_ACCOUNTS === "true" && (
            <Route             
              name="chart-accounts"
              path="/chart-accounts"
              element={<ChartAccountsView pageRef={pageRef} />}       
            />
          )}

          {BRANCH_NAME === "dev" ||
          (FEATURE_TOGGLE_REPORTS !== "true" &&
            isActiveStatus) ? (
              <Route                
                name="reports"
                path="/reports"
                element={<ReportsView  pageRef={pageRef} />}       
                exact
              />
            ) : null}

          {BRANCH_NAME === "dev" ||
          (FEATURE_TOGGLE_REPORTS !== "true" &&
            isActiveStatus) ? (
              BRANCH_NAME === "dev" && <Route                
                name="reportsOneFront"
                path="/reports/onefront"
                element={<ReportOnefront  pageRef={pageRef} />}       
                exact
              />
            ) : null}

          {FEATURE_TOGGLE_REPORTS === "true" ||
          (FEATURE_TOGGLE_REPORTS !== "true" &&
            isActiveStatus) ? (
              <Route                
                name="reportshome"
                path="/reports/home"
                element={<ReportsHomeView  pageRef={pageRef} />}       
              />                
            ) : null}
          
          {FEATURE_TOGGLE_REPORTS === "true" ||
          (FEATURE_TOGGLE_REPORTS !== "true" &&
            isActiveStatus) ? (
              <Route                
                name="vat"
                path="/reports/vat"
                element={<VatReportView  pageRef={pageRef} />}       
                exact
              />
            ) : null}
          
          {FEATURE_TOGGLE_REPORTS === "true" ||
          (FEATURE_TOGGLE_REPORTS !== "true" &&
            isActiveStatus) ? (
              <Route                
                name="vat-detail"
                path="/reports/vat-detail/:id"
                element={<VatDetailReportView  pageRef={pageRef} />}       
                exact
              />
            ) : null}
          
          {FEATURE_TOGGLE_REPORTS === "true" ||
          (FEATURE_TOGGLE_REPORTS !== "true" &&
            isActiveStatus) ? (
              <Route                
                name="vat"
                path="/reports/vat-entries"
                element={<VatEntriesView  pageRef={pageRef} />}       
                exact
              />
            ) : null}
          
          {FEATURE_TOGGLE_REPORTS === "true" ||
          (FEATURE_TOGGLE_REPORTS !== "true" &&
            isActiveStatus) ? (
              <Route                
                name="aliquote-detail"
                path="/reports/aliquote-detail/:id"
                element={<AliquoteDetailView  pageRef={pageRef} />}       
                exact
              />
            ) : null}

          {FEATURE_TOGGLE_TAX_CREDIT === "true" && (
            <Route 
              name="tax-credit"
              path="/tax-credit"
              element={<TaxCreditView pageRef={pageRef}  />}       
            />
          )}

          {FEATURE_TOGGLE_TAX_CREDIT === "true" && (
            <Route              
              name="tax-credit-detail"
              path="/tax-credit-detail/:id"
              element={<TaxCreditDetailView
                pageRef={pageRef}                  
              />}       
            />
          )}

          <Route            
            name="tspayonboarding"
            path="/tspay-onboarding"
            element={ <TsPayOnboardingLandingView
              pageRef={pageRef}                
            />}       
          />           
          
          <Route            
            name="createnewcontact"
            path="/create-contact"
            element={<CreateNewContactView pageRef={pageRef}  isPage={true} />}       
          />                      

          <Route
            path="/password-dimenticata"
            name="forgotPassword"    
            element={<SSOView  />}              
          />

          <Route
            path="/customer-management"
            name="customerManagement"    
            element={<DbxChildAppView url={CUSTOMER_MANAGEMENT_URL} />}              
          />     
          <Route
            path="*"
            element={<Navigate to="/" replace />}
          />       
        </Routes>
      ) : (
        (user?.profile?.uuid ? user?.profile?.uuid : user?.profile?.id) && <Spinner size="large" />
      )}
    </>
  );
};

export default RoutesView;
